import { useState, useEffect } from "react";
import { logo } from "../assets";
import { baseUrl, secondaryColor } from "../constants/constants";
import { NavLink, useNavigate } from "react-router-dom";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Only 6 fields
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [ setCanResend] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const navigate = useNavigate();

  // Handle OTP input change and move focus
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      if (value && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  // Handle backspace key press
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      const updatedOtp = [...otp];
      updatedOtp[index - 1] = "";
      setOtp(updatedOtp);
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  // Handle OTP verification
  const verifyOtp = () => {
    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      setError("Please enter all 6 digits of the OTP.");
      return;
    }

    setIsLoading(true);
    setError("");

    const email = localStorage.getItem("email");
    const requestPayload = JSON.stringify({ email, otp: otpCode });

    fetch(`${baseUrl}validate-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: requestPayload,
    })
      .then((response) => response.json())
      .then((result) => {
        setIsLoading(false);
        if (result.status) {
          localStorage.setItem("token", result.token);
          navigate("/passwordchange");
        } else {
          setOtp(["", "", "", "", "", ""]); // Reset 6 fields
          setError("Invalid OTP. Please try again.");
          setAttempts((prev) => prev + 1);

          if (attempts >= 3) {
            setError("Too many failed attempts.");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }

          document.getElementById("otp-input-0").focus();
        }
      })
      .catch(() => {
        setIsLoading(false);
        setError("An error occurred. Please try again.");
      });
  };

  // Handle OTP resend
  // const resendOtp = () => {
  //   setIsLoading(true);
  //   setError("");

  //   const email = localStorage.getItem("email");
  //   if (!email) {
  //     setIsLoading(false);
  //     setError("No email found. Please log in again.");
  //     return;
  //   }

  //   const requestPayload = JSON.stringify({ email });

  //   fetch(`${baseUrl}resend-otp`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: requestPayload,
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       setIsLoading(false);
  //       if (result.status) {
  //         setTimer(60);
  //         setCanResend(false);
  //       } else {
  //         setError(result.message || "Failed to resend OTP.");
  //       }
  //     })
  //     .catch(() => {
  //       setIsLoading(false);
  //       setError("An error occurred while resending OTP.");
  //     });
  // };

  // Timer countdown logic
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(interval);
    } else {
      setCanResend(true);
    }
  }, );

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center w-full lg:w-1/2 px-6 sm:px-10 py-10 bg-white rounded-lg">
        <img className="h-14 absolute top-1 left-0 m-4" src={logo} alt="Logo" />

        <h1 className="text-3xl font-bold text-left mb-6" style={{ color: secondaryColor }}>
          Verify OTP
        </h1>

        {/* OTP Input Fields */}
        <div className="flex gap-2 justify-center w-full max-w-[240px] sm:max-w-[300px]">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-10 h-12 border border-gray-300 text-center text-xl rounded-md focus:outline-none transition-all duration-300"
              inputMode="numeric"
            />
          ))}
        </div>

        {/* Error Message */}
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

        {/* Verify Button */}
        <button
          onClick={verifyOtp}
          className="mt-4 px-6 py-2 bg-green-900 text-white rounded-lg disabled:opacity-50"
          disabled={isLoading}
        >
          {isLoading ? "Verifying..." : "Verify OTP"}
        </button>

        {/* Resend OTP */}
        {/* <div className="text-center mt-4">
          {canResend ? (
            <button onClick={resendOtp} className="text-blue-500 text-sm">
              Resend OTP
            </button>
          ) : (
            <p className="text-gray-500 text-sm">Resend available in {timer}s</p>
          )}
        </div> */}

        {/* Sign Up Link */}
        <div className="mt-6 text-sm text-gray-500">
          Don't have an account?{" "}
          <NavLink to="/sign-up" className="text-[#2cb4d5]">
            Sign Up
          </NavLink>
        </div>

        <div className="w-full border-t border-gray-300 my-4"></div>
        <p className="text-xs text-center text-gray-500">
          &copy; {new Date().getFullYear()} YehaCard. All rights reserved. Powered by PSI.
        </p>
      </div>
    </div>
  );
};

export default VerifyOtp;
